import styled from 'styled-components';

export const SideWavePill = styled.div`
    --pill-pad: 0.25rem;
    --pill-gap: 0.25rem;
    /* Largura útil interna = caixa menos padding; cada metade = (útil - gap) / 2 */
    --segment: calc((100% - 2 * var(--pill-pad) - var(--pill-gap)) / 2);

    position: relative;
    display: flex;
    align-items: stretch;
    gap: var(--pill-gap);
    box-sizing: border-box;
    flex-shrink: 0;
    border-radius: 1.875rem;
    background: ${({ theme }) => theme.colors['neutral-200']};
    padding: var(--pill-pad);
    min-width: 13.5rem;
    isolation: isolate;
`;

export const SideWaveIndicator = styled.span<{ $activeIndex: number }>`
    position: absolute;
    top: var(--pill-pad);
    bottom: var(--pill-pad);
    left: ${({ $activeIndex }) =>
        $activeIndex === 0
            ? 'var(--pill-pad)'
            : 'calc(var(--pill-pad) + var(--segment) + var(--pill-gap))'};
    width: var(--segment);
    border-radius: 1.5rem;
    background: ${({ theme }) => theme.colors['supernova-500']};
    box-shadow: 0 4px 10px rgba(38, 99, 168, 0.12);
    transition:
        left 360ms cubic-bezier(0.22, 1, 0.36, 1),
        box-shadow 360ms ease;
    will-change: left;
`;

export const SideWaveOption = styled.button<{ $isActive: boolean }>`
    z-index: 1;
    flex: 1 1 0;
    min-width: 0;
    border: none;
    border-radius: 1.5rem;
    background: transparent;
    color: ${({ theme, $isActive }) =>
        $isActive ? theme.colors['neutral-900'] : theme.colors['neutral-500']};
    cursor: pointer;
    min-height: 2.25rem;
    padding: 0.35rem 0.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    font-size: 0.95rem;
    font-weight: 600;
    transition:
        color 220ms ease,
        transform 220ms ease,
        opacity 220ms ease;
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0.78)};

    &:hover {
        opacity: 1;
    }

    &:active {
        transform: scale(0.98);
    }
`;

export const SideWaveVisual = styled.div<{ $isLeft: boolean }>`
    color: currentColor;
    transform: ${({ $isLeft }) => `rotateY(${$isLeft ? '0deg' : '180deg'})`};
    transition:
        transform 360ms cubic-bezier(0.22, 1, 0.36, 1),
        color 220ms ease;

    div {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    svg {
        height: 1.25rem;
        width: 1.25rem;
    }
`;
